<template>
  <aside class="sidebar" :class="{ 'sidebar--open': open }">
    <div class="sidebar__brand">
      <router-link to="/dashboard" class="brand"
        ><span class="brand__mark"><img src="/prexens-mark.svg" alt="" /></span
        ><span
          ><strong>Prexens</strong><small>Collection manager</small></span
        ></router-link
      >
      <button
        class="sidebar__close"
        type="button"
        aria-label="Fermer le menu"
        @click="$emit('close')"
      >
        ×
      </button>
    </div>
    <router-link to="/parse" class="sidebar__create"
      ><span aria-hidden="true">＋</span> Suivre une annonce</router-link
    >
    <nav class="sidebar__nav" aria-label="Navigation principale">
      <section
        v-for="section in sections"
        :key="section.label"
        class="nav-section"
      >
        <p>{{ section.label }}</p>
        <router-link
          v-for="item in section.items"
          :key="item.to"
          :to="item.to"
          class="nav-link"
        >
          <font-awesome-icon :icon="['fas', item.icon]" /><span>{{
            item.label
          }}</span>
        </router-link>
      </section>
    </nav>
    <div class="sidebar__footer">
      <router-link to="/profile" class="account"
        ><span class="account__avatar">P</span
        ><span><strong>Mon espace</strong><small>Préférences</small></span
        ><b>›</b></router-link
      >
      <button type="button" :disabled="loggingOut" @click="logout">
        {{ loggingOut ? "Déconnexion…" : "Se déconnecter" }}
      </button>
    </div>
  </aside>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHouse,
  faBell,
  faGavel,
  faBoxOpen,
  faBoxesStacked,
  faTags,
  faMobileScreen,
  faMagnifyingGlass,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";
library.add(faHouse, faBell, faGavel, faBoxOpen, faBoxesStacked, faTags, faMobileScreen, faMagnifyingGlass, faTruckFast);
import { logout as endSession } from "../auth";
import { closeDetails } from "../detailStack";
export default {
  name: "SidebarLeft",
  components: { FontAwesomeIcon },
  props: { open: { type: Boolean, default: false } },
  emits: ["close"],
  data: () => ({
    loggingOut: false,
    sections: [
      {
        label: "Aujourd'hui",
        items: [
          { to: "/dashboard", label: "Vue d’ensemble", icon: "house" },
          { to: "/jobs", label: "Échéances", icon: "bell" },
        ],
      },
      {
        label: "Acquisitions",
        items: [
          { to: "/veille", label: "Veille", icon: "magnifying-glass" },
          { to: "/offers", label: "Annonces suivies", icon: "gavel" },
          { to: "/myoffers", label: "Achats remportés", icon: "box-open" },
          { to: "/packages", label: "Colis", icon: "truck-fast" },
        ],
      },
      {
        label: "Inventaire",
        items: [
          { to: "/items", label: "Collection", icon: "boxes-stacked" },
          { to: "/sales", label: "Ventes", icon: "tags" },
        ],
      },
      {
        label: "Réglages",
        items: [
          { to: "/notifications", label: "Notifications", icon: "mobile-screen" },
        ],
      },
    ],
  }),
  methods: {
    async logout() {
      if (this.loggingOut) return;
      this.loggingOut = true;
      closeDetails();
      try {
        await endSession();
      } finally {
        this.loggingOut = false;
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 50;
  display: flex;
  width: 236px;
  flex-direction: column;
  padding: calc(22px + var(--safe-top)) 16px calc(16px + var(--safe-bottom));
  background: #101827;
  color: #dbe4f0;
}
.sidebar__brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 22px;
}
.brand {
  display: flex;
  align-items: center;
  gap: 11px;
  color: #fff;
  text-decoration: none;
}
.brand__mark {
  display: grid;
  width: 36px;
  height: 36px;
  overflow: hidden;
  place-items: center;
  border-radius: 11px;
}
.brand__mark img {
  display: block;
  width: 36px;
  height: 36px;
}
.brand strong,
.brand small {
  display: block;
}
.brand strong {
  font-size: 15px;
}
.brand small {
  margin-top: 2px;
  color: #77859a;
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.sidebar__close {
  display: none;
  border: 0;
  background: none;
  color: #9aa8ba;
  font-size: 27px;
}
.sidebar__create {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  border-radius: 10px;
  background: #8df0c8;
  color: #10201b;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}
.sidebar__nav {
  flex: 1;
  overflow: auto;
}
.nav-section {
  margin-bottom: 24px;
}
.nav-section > p {
  margin: 0 10px 8px;
  color: #607087;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.nav-link {
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 11px;
  margin: 2px 0;
  padding: 0 11px;
  border-radius: 9px;
  color: #98a7ba;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}
.nav-link svg {
  width: 16px;
  color: #6f7e93;
}
.nav-link:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}
.nav-link.router-link-active {
  background: #253047;
  color: #fff;
  box-shadow: inset 3px 0 #8df0c8;
}
.nav-link.router-link-active svg {
  color: #8df0c8;
}
.sidebar__footer {
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}
.account {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px;
  color: #c9d3df;
  text-decoration: none;
}
.account__avatar {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 50%;
  background: #29364a;
  color: #8df0c8;
  font-weight: 800;
}
.account > span:nth-child(2) {
  flex: 1;
}
.account strong,
.account small {
  display: block;
  font-size: 11px;
}
.account small {
  margin-top: 2px;
  color: #6f7e93;
}
.sidebar__footer > button {
  margin: 8px 7px 0;
  padding: 0;
  border: 0;
  background: none;
  color: #6f7e93;
  font-size: 11px;
  cursor: pointer;
}
@media (max-width: 1100px) {
  .sidebar {
    transform: translateX(-105%);
    transition: transform 0.22s ease;
    box-shadow: 18px 0 50px rgba(0, 0, 0, 0.3);
  }
  .sidebar--open {
    transform: translateX(0);
  }
  .sidebar__close {
    display: block;
  }
}
</style>
